import ConfirmPopup from "../util/confirm_popup";
import ListItemActionButton from "./ListItemActionButton";
import ListItemContainer from "./ListItemContainer";

interface LibraryListItemProps {
  model: any;
  index: number;
  onPress: (model: any) => void;
  addCategory: (model: any) => void;
  setCategoryVisibility: (id: string, visibility: "hidden" | "visible") => void;
  editCategory: (model: any) => void;
  deleteCat: string;
  setDeleteCat: (state: string) => void;
  handleConfirm: () => void;
  handleCancel: () => void;
  showDialog: boolean;
  setShowDialog: (state: boolean) => void;
}

const LibraryListItem = ({
  model,
  index,
  onPress,
  addCategory,
  setCategoryVisibility,
  editCategory,
  showDialog,
  deleteCat,
  setShowDialog,
  setDeleteCat,
  handleConfirm,
  handleCancel,
}: LibraryListItemProps) => {
  const isVisible = model?.visibility === "visible";

  return (
    <ListItemContainer index={index} onClick={() => onPress(model)} extraClassName="item-btn">
      <div style={{ marginTop: 0, display: "flex", width: "100%" }}>
        <div className="projects-item-photo">
          <img
            src={model.image}
            style={{
              padding: 1,
              width: 70,
              height: 70,
              objectFit: "cover",
            }}
          />
        </div>
        <div
          className="projects-item-cat"
          style={{
            flex: 1,
            display: "flex",
            alignSelf: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ fontSize: 14, userSelect: "none" }}>ID: {model.id}</div>
          <div style={{ fontSize: 16, userSelect: "none" }}>{model.title}</div>
          <div style={{ fontSize: 14, color: "gray", userSelect: "none" }}>{model.detail}</div>
        </div>
        <div className="projects-item-cat" style={{ display: "flex", justifyContent: "flex-end" }}>
          <ListItemActionButton onClick={() => addCategory(model)} color="purple">
            Add Subcategory
          </ListItemActionButton>

          <ListItemActionButton
            onClick={() => setCategoryVisibility(model.id, isVisible ? "hidden" : "visible")}
            color="gray"
          >
            {isVisible ? "Hide" : "Show"}
          </ListItemActionButton>

          <ListItemActionButton onClick={() => editCategory(model)} color="blue">
            Edit
          </ListItemActionButton>

          <ListItemActionButton
            onClick={() => {
              setShowDialog(true);
              setDeleteCat(model.id);
            }}
            color="red"
          >
            Delete
          </ListItemActionButton>
        </div>
      </div>
      {showDialog && deleteCat.toString() === String(model.id) ? (
        <ConfirmPopup
          message={"Enter 75329 to confirm delete category#" + model.id}
          confirmValue="75329"
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      ) : (
        <></>
      )}
    </ListItemContainer>
  );
};

export default LibraryListItem;
